module.exports = __webpack_public_path__ + "img/te_get.1d85e20.png";